/*  ==========================================================================
		PHP Variables
		========================================================================== */

  // If you need to access variables such as template url, or AJAX url within this file you can use the variable php_variables.template_url or php_variables.ajax_url
  // which has been passed in via enqueue-scripts.php


/*  ==========================================================================
		Grid variables - needed for gridcarousel__init
		========================================================================== */

  // NOTE: If your updating this make sure to also update the SASS Variables in _variables.scss
  var $grid_sizes = {
    sm: "550",
    md: "700",
    lg: "1000",
    xl: "1200",
    ws: "1400",
    xw: "1600"
  };

/*  ==========================================================================
		Device Detection - Check if is mobile or ipad
		========================================================================== */

  var isMobile = false; // initiate as false
  var isTouchDevice = !!("ontouchstart" in window);

  if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    isMobile = true;
  }
/*  ==========================================================================
		GENERAL - add linklines to links
		========================================================================== */

function links__init() {
  var $links = $("a").not(".noline, .noline a, .line--added");

  if ($links.length > 0) {
    $links.each(function () {
      var $this = $(this);
      var $icon = $(".fa, .fas, .far, .fal, .fab", $this);

      if ($("img", $this).length < 1) {
        $this.wrapInner("<span class='linkline'>");
        $this.addClass("line--added");
        if ($icon.length > 0) {
          if ($icon.hasClass("fa--left")) {
            $icon.insertBefore($(".linkline", $this));
          } else {
            $icon.insertAfter($(".linkline", $this));
          }
        }
      }
    });
  }
} // links__init()

links__init();

/*  ==========================================================================
    GENERAL - sharinglinks
    ========================================================================== */

$(".sharelink--popup").click(function (e) {
  e.preventDefault();
  window.open($(this).attr("href"), "share-dialog", "width=550,height=436");
});

/*  ==========================================================================
    GENERAL - accordion
    ========================================================================== */

$(".accordion__question").click(function () {
  $(this).closest(".accordion__item").toggleClass("accordion__item--open");
});

/*  ==========================================================================
    GENERAL - prevent click on social icons btn as its just for hover
    ========================================================================== */

$(".socialicons__btn").click(function (e) {
  e.preventDefault();
});

/*  ==========================================================================
    GENERAL - Initiate plyr (custom video controls)

    This is automatically disabled on builds, to enable uncomment the JS here
    and then go to functions / enqueue-scripts and enqueue-styles to uncomment and enable the css and JS 

    ========================================================================== */

// plyrs__init();

// function plyrs__init() {
//   // Get all videos that are click to play
//   var $plyrs = $(".mediavideo").not(".mediavideo--autoplay");

//   if ($plyrs.length > 0) {
//     $plyrs.each(function () {
//       var plyr = $(this).find(".mediavideo__video");
//       new Plyr(plyr, {
//         controls: ["play", "progress", "mute", "current-time"],
//         hideControls: true,
//         invertTime: false,
//         tooltips: { controls: false, seek: false }
//       });
//     });
//   }
// } // plyrs__init()

/*  ==========================================================================
    AJAX - AJAX load more / paging
    ========================================================================== */

  if ($(".paging__loadmore").length){
  $(".paging__loadmore").click(function () {
    var button = $(this);
    var data = {
      action: "loadmore",
      query: php_variables.posts, // that's how we get params from wp_localize_script() function
      page: php_variables.current_page
    };
    var button_text; // create variable to store button text

    // This AJAX triggers a PHP hook within function-hooks.php called ajax_loadmore_handler
    $.ajax({
      url: php_variables.ajax_url, // AJAX handler
      data: data,
      type: "POST",
      beforeSend: function (xhr) {
        button_text = button.html(); // store current button text
        button.text("Loading..."); // change the button text, to let the user know we are loading more posts
      },
      success: function (data) {
        if (data) {
          button.html(button_text); // set back to previous button text
          $(".loadmore-container").append(data); // insert new posts to the loadmore-container, this should be the row that includes the posts
          php_variables.current_page++;
          // if last page, remove the button..
          if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
            button.remove();
          }
          // Re-init links to make sure linklines on newly loaded content still work
          links__init();
        } else {
          button.remove(); // if no data, remove the button as well
        }
      }
    });
  });

  }

/*  ==========================================================================
    Scroll effects
    ========================================================================== */

function effects__init() {
  var $effects = $(".effect");
  if ($effects.length > 0) {
    $effects.each(function () {
      var $el = $(this);
      $el.waypoint({
        handler: function (direction) {
          if (direction === "down") {
            $el.addClass("effect--ready");
          } else {
            $el.removeClass("effect--ready");
          }
        },
        offset: "95%"
      });
    });
  }
} // effects__init()

effects__init();

/*  ==========================================================================
    Text scroll
    ========================================================================== */

var default_animation_speed = 5;

var el_class = "text-scroll";
var inner_class = "text-scroll__wrap";
var inner_content_class = "text-scroll__content";

$("." + el_class).each(function () {
  textscroll__init($(this));
});

$(window).resize(function () {
  $("." + el_class).each(function () {
    //textscroll__resize($(this));
  });
});

function textscroll__init($el) {
  // Setup two scroll wraps (duplicate the HTML)
  $el.wrapInner("<div class='" + inner_class + "'></div>");
  $el.find("." + inner_class).wrapInner("<div class='" + inner_content_class + "'></div>");
  $el
    .find("." + inner_content_class)
    .clone()
    .appendTo($el.find("." + inner_class));

  $el
    .find("." + inner_content_class)
    .clone()
    .appendTo($el.find("." + inner_class));

  $el
    .find("." + inner_content_class)
    .clone()
    .appendTo($el.find("." + inner_class));
  // Setup animation times
  //textscroll__resize($el);

  // Once everything is set up, add "loaded" class
  $el.addClass(el_class + "--loaded");
}

function textscroll__resize($el) {
  // Check if element has custom speed or default
  var animation_speed = default_animation_speed;
  if ($el.data("speed")) {
    animation_speed = $el.data("speed");
  } else {
    animation_speed = default_animation_speed;
  }

  // Set animation time
  var linelength = $("." + inner_class, $el).width();
  var distance = linelength;
  var speed = animation_speed * 0.01;
  var duration = distance / speed;
  var delay = 0 - duration / 3;

  $el.find("." + inner_class).css("animation-duration", duration + "ms");
  $el.find("." + inner_class + ":first-child()").css("animation-delay", delay + "ms");
  $el.find("." + inner_class + ":nth-child(2)").css("animation-delay", delay * 2 + "ms");
  $el.find("." + inner_class + ":nth-child(3)").css("animation-delay", delay * 3 + "ms");
  $el.find("." + inner_class + ":nth-child(4)").css("animation-delay", delay * 4 + "ms");
}

/*  ==========================================================================
			Grid Carousel (Currently used on Featured Posts & Featured People)
			========================================================================== */

var $grid_carousels = $(".row--carousel .owl-carousel");

if ($grid_carousels.length > 0) {
  gridcarousel__init();
}

function gridcarousel__init() {
  $grid_carousels.each(function () {
    var $this = $(this);

    // Optional data attribute settings
    var $autoplay = $(this).data("autoplay") ? $(this).data("autoplay") : false;
    var $autoplay_timeout = $(this).data("autoplay-timeout") ? $(this).data("autoplay-timeout") : 5000;
    var $loop = $(this).data("loop") ? $(this).data("loop") : false;
    var $nav = $(this).data("nav") ? $(this).data("nav") : false;
    var $dots = $(this).data("dots") ? $(this).data("dots") : false;
    var $autoheight = $(this).data("autoheight") && $(this).data("autoheight") == "disable" ? false : true;

    var responsive_array = carousel__responsive_array($this);
    $this.owlCarousel({
      autoplay: $autoplay,
      autoplayTimeout: $autoplay_timeout,
      loop: $loop,
      nav: $nav,
      dots: $dots,
      items: 4,
      navText: ["<i class='far fa-arrow-left'></i>", "<i class='far fa-arrow-right'></i>"],
      responsive: responsive_array,
      autoHeight: false
    });

    $this.on("resized.owl.carousel", function (event) {
      // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    });
  });
} // gridcarousel__init()

/*  ==========================================================================
    Grid Carousel - Create responsive array 
    ========================================================================== */

function carousel__responsive_array($this) {
  var classList = $this.find(".col").attr("class").split(/\s+/);
  var responsive_array = {};
  $.each(classList, function (index, item) {
    // if is col width class
    if (item.indexOf("col-") !== -1) {
      var item_width = 0;
      var items_items = 4;
      item = item.replace("col-", "");
      // get min width from col class
      let item_gridsize = item.split("-")[0];
      // check this is a string not a number, this will remove up cols that dont have a grid size e.g. col-1-2
      if (isNaN(item_gridsize)) {
        item = item.replace(item_gridsize + "-", "");
        item_width = $grid_sizes[item_gridsize];
      } else {
        item_width = 0;
      }
      // split rest of class into sections (this should now be something like "1-4")
      let item_class_sections = item.split("-");
      // divide second number (e.g 4) by first number (e.g 1) to get number of items
      var item_items = "";
      if (item_class_sections[1]) {
        item_items = item_class_sections[1] / item_class_sections[0];
      } else {
        item_items = 1; // if there isn't a second number it must be a single grid
      }
      responsive_array[item_width] = {
        items: item_items
      };
    }
  });

  return responsive_array;
}

/*  ==========================================================================
	NAVIGATION - mobnav
	========================================================================== */

  var $mobnav = $(".mobnav");
  var $siteheaderbd = $(".siteheader__bd");
  var $mobnavtoggle = $(".mobnav-toggle");
  var mobnavopenclass = "mobnavopen";

  function mobnav__init() {
    // Open mobnav on click the toggle
    $mobnavtoggle.on("click touchend", function (e) {
      e.preventDefault();
      if (!$("body").hasClass(mobnavopenclass)) {
        // IT'S NOT OPEN...
        var $mobnav_height = window.innerHeight - $siteheaderbd.outerHeight(false);
        $mobnav.height($mobnav_height);
        $("body").addClass(mobnavopenclass);
      } else {
        // IT'S OPEN...
        $mobnav.height(0);
        $("body").removeClass(mobnavopenclass);
      }
    });

    $(window).resize(mobnav__resize); 
  } // mobnav__init()

  // On resize check mobnav height is still right
  function mobnav__resize() {
    if ($("body").hasClass(mobnavopenclass)) {
      var $mobnav_height = window.innerHeight - $siteheaderbd.outerHeight(false);
      $mobnav.height($mobnav_height);
    }
  } // mobnav__resize()

  mobnav__init();

/*  ==========================================================================
    NAVIGATION - mobnav dropdowns
    ========================================================================== */

  $(".mobnav .sitenav__item--hasdropdown .sitenav__item__dropdownarrow").click(function (e) {
    e.preventDefault();
    $(this).closest(".sitenav__item").toggleClass("sitenav__item--open");
  });
  
/*  ==========================================================================
	NAVIGATION - Search
	========================================================================== */

  // Search open & close
  if ($(".siteheader__search").length) {
    $(".search-toggle").click(function () {
      if ($(this).closest(".siteheader").find(".siteheader__search").hasClass("siteheader__search--open")) {
        $(this).closest(".siteheader").find(".siteheader__search").removeClass("siteheader__search--open");
      } else {
        $(this).closest(".siteheader").find(".siteheader__search").addClass("siteheader__search--open");
        $(this).closest(".siteheader").find(".siteheader__search .searchform__input input").focus();
      }
    });
  }

  // Hide search when clicking anywhere else on the page
  $(document).mouseup(function (e) {
    var search_container = $(".siteheader__search");
    var search_toggle = $(".search-toggle");
    if (
      !search_container.is(e.target) &&
      search_container.has(e.target).length === 0 &&
      !search_toggle.is(e.target) &&
      search_toggle.has(e.target).length === 0
    ) {
      $(search_container).removeClass("siteheader__search--open");
    }
  });

/*  ==========================================================================
  Polyfill IE11 for forEach
  ========================================================================== */

  if ("NodeList" in window && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, thisArg) {
      thisArg = thisArg || window;
      for (var i = 0; i < this.length; i++) {
        callback.call(thisArg, this[i], i, this);
      }
    };
  }
